import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { cn } from '../../../../utils/utils';

let nextTitleId = 0;

/**
 * Panel with a title bar (and an optional icon button, usually Close).
 * The title's id (`titleId`, auto-generated unless set) can name a dialog:
 * pass the same id to app-modal-component's `[labelledBy]`.
 */
@Component({
  selector: 'app-form-wrapper',
  standalone: true,
  imports: [],
  templateUrl: './form-wrapper.component.html',
  styleUrl: './form-wrapper.component.css',
})
export class FormWrapperComponent {
  /** The `title` input would otherwise also land on the host as a native tooltip. */
  @HostBinding('attr.title') readonly hostTitle = null;

  @Input({ required: true }) title = '';
  @Input({ required: false }) mainClass = '';
  @Input({ required: false }) contentClass = '';
  @Input() icon = '';
  /** Id of the title heading, for aria-labelledby on the surrounding dialog. */
  @Input() titleId = `bk-fw-title-${nextTitleId++}`;
  @Output() iconClick = new EventEmitter();

  merge = cn;

  get isClose(): boolean {
    return this.icon === 'cancel' || this.icon === 'close';
  }

  /** "cancel" reads as Close; anything else is named after its icon. */
  get iconLabel(): string {
    if (this.isClose) return 'Close';
    const words = this.icon.replace(/[_-]+/g, ' ').trim();
    return words ? words[0].toUpperCase() + words.slice(1) : '';
  }
}
